<template>
  <div class="lang-panel lang-panel-from">
    <div class="search-container">
      <div class="search-wrapper"><input placeholder="搜索语言" class="search-input" type="text"
                                         v-model="search"></div>
    </div>
    <div class="search-result"
         style="position: relative; overflow: hidden; width: 100%; height: auto; min-height: 0px; max-height: 372px;">
      <div
          style="position: relative; overflow: scroll; margin-right: -15px; margin-bottom: -15px; min-height: 15px; max-height: 387px;"></div>
      <div
          style="position: absolute; height: 6px; transition: opacity 200ms ease 0s; opacity: 0; right: 2px; bottom: 2px; left: 2px; border-radius: 3px;">
        <div
            style="position: relative; display: block; height: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2); width: 0px;"></div>
      </div>
      <div
          style="position: absolute; width: 6px; transition: opacity 200ms ease 0s; opacity: 0; right: 2px; bottom: 2px; top: 2px; border-radius: 3px;">
        <div
            style="position: relative; display: block; width: 100%; cursor: pointer; border-radius: inherit; background-color: rgba(0, 0, 0, 0.2);"></div>
      </div>
    </div>
    <div class="lang-table" style="position: relative; overflow: hidden; width: 100%; height: 488.425px;">
      <div style="position: absolute; inset: 0px; overflow-y: scroll; margin-right: -15px; margin-bottom: -15px;">
        <div class="letter-block" v-for="(item,index) in to?languageto:lanuagefrom" :key="index">
          <p class="letter-title" :ref="item.label">{{ item.label }}</p>
          <div>
	            <span class="lang-item" v-for="(itm,idx) in item.lanuagesFrom" :key="idx"
	                  :data-track-text="`选择语种${itm.label}`"
	                  :aria-label="`选择语种${itm.label}`"
	                  :class="val===itm.value?'selected':domain===''&&terminology === '暂不使用术语'?'':
                  ((domain==='novel'||domain==='wiki'||terminology !== '暂不使用术语')?(to?(itm.value==='en'?'':'disabled'):
                  (itm.value==='zh'?'':'disabled')):itm.value==='zh'||itm.value==='en'||itm.value==='auto'?'':'disabled')"
                  @click="changeVal(itm.value)">{{ itm.label }}</span>
          </div>
        </div>
      </div>
    </div>
    <ol class="letter-index-ol">
	      <li class="letter-index" v-for="(item,index) in to?languageto:lanuagefrom" :key="index" :data-track-text="`跳转语种索引${item.label}`" :aria-label="`跳转语种索引${item.label}`" @click="jump(item.label)">
        {{ item.label }}
      </li>
    </ol>
  </div>

</template>

<script>
import lanuagefrom from "./languagefrom.json";
import languageto from "./languageto.json";

export default {
  name: "LangPanel",
  props: {
    to: {
      type: Boolean,
      default: false
    },
    val: {
      type: String,
      default: ''
    },
    domain: {
      type: String,
      default: ''
    },
    terminology: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      lanuagefrom: lanuagefrom,
      languageto: languageto,
      search: ''
    }
  },
  watch: {
    search(v) {
      debugger
      if (v === '' || v === undefined || v === null) {
        if (this.to) {
          this.languageto = languageto
        } else {
          this.lanuagefrom = lanuagefrom
        }
        return
      }
      let resLang = this.to ? this.languageto : this.lanuagefrom
      // 创建一个空数组用于存储匹配的结果
      const matches = [];
      // 遍历数据结构中的每个对象
      resLang.forEach(item => {
        // 判断当前对象的 label 是否包含搜索关键字
        if (item.label.includes(v)) {
          // 如果匹配成功，则将当前对象添加到匹配结果数组中
          matches.push(item);
        } else {
          // 如果当前对象的 label 不匹配，则继续遍历其下的 languagesFrom 数组
          const matchesChild = [];
          const child = {}
          child['label'] = item['label']
          item.lanuagesFrom.forEach(language => {
            // 判断当前语言对象的 label 是否包含搜索关键字
            if (language.label.includes(v)) {
              // 如果匹配成功，则将当前语言对象添加到匹配结果数组中，并将其所属的父对象也一并添加
              matchesChild.push(language);
            }
          })
          if (matchesChild.length > 0) {
            child['lanuagesFrom'] = matchesChild
            matches.push(child);
          }
        }
      })
      if (this.to) {
        this.languageto = matches
      } else {
        this.lanuagefrom = matches
      }
    }
  },
  methods: {
    /* 目录点击定位效果：有兼容问题，借鉴了很多其他方法却一直不成功，无奈之后使用了scrollIntoView */
    jump(name) {
      debugger
      this.$refs[name][0].scrollIntoView({
        behavior: "smooth",  // 平滑过渡
        block: "start"    // 上边框与视窗顶部平齐
      })
    },
    changeVal(val) {
      if (this.domain !== '' && val !== 'zh' && val !== 'en' && val !== 'auto') {
        return;
      }
      if (this.terminology !== '暂不使用术语' && val !== 'zh' && val !== 'en') {
        return;
      }
      this.$emit('custom-event', val);
    }
  }
}
</script>

<style src="./LangPanel.less" lang="less" scoped/>
